import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { ordersApi } from '@entities/order';
import { Skeleton, UiText } from '@shared/ui';

import cls from './Orders.module.css';
import { OrdersContent } from './ui/OrdersContent';

export const OrdersPage = () => {
    const { t } = useTranslation();
    const { data: orders, isPending, isError } = useQuery(ordersApi.getOrdersQueryOptions());

    if (isPending) {
        return (
            <main className={cls.ordersPage} aria-busy="true">
                <div className={cls.tabsSkeleton}>
                    <Skeleton width={140} height={40} border="6px" />
                    <Skeleton width={120} height={40} border="6px" />
                </div>
                {[0, 1].map((section) => (
                    <section key={section} className={cls.cardSkeleton}>
                        <Skeleton width={180} height={24} border="6px" />
                        <Skeleton height={48} border="6px" />
                        <Skeleton height={44} border="6px" />
                        <Skeleton height={44} border="6px" />
                        <Skeleton height={44} border="6px" />
                    </section>
                ))}
            </main>
        );
    }

    if (isError || !orders) {
        return (
            <main className={cls.stateCard}>
                <UiText role="alert">{t('orders.page.errors.load')}</UiText>
            </main>
        );
    }

    if (orders.length === 0) {
        return (
            <main className={cls.stateCard}>
                <UiText>{t('orders.page.empty')}</UiText>
            </main>
        );
    }

    return <OrdersContent orders={orders} />;
};
